export default __webpack_public_path__ + "static/media/order-rate.270537d0.svg";